import { Routes } from '@angular/router';
import { LoginPage } from './pages/login/login.page';

export const authRoutes: Routes = [
    // Onboarding é a entrada principal do auth (novo cliente cai no wizard).
    { path: '', redirectTo: 'onboarding', pathMatch: 'full' },
    { path: 'login', component: LoginPage },
    // "Criar conta" (LP, link do login) cai sempre no wizard. O plano escolhido na
    // LP viaja pelo `selected_plan` e é consumido no fim do wizard, não por query
    // param. Login só via "Já tenho conta" no welcome.
    { path: 'new-account', redirectTo: 'onboarding', pathMatch: 'full' },
    {
        path: 'company-onboarding',
        loadComponent: () =>
            import('./pages/company-onboarding/company-onboarding.page').then(
                x => x.CompanyOnboardingPage
            ),
    },
    {
        path: 'onboarding',
        loadChildren: () =>
            import('./pages/onboarding-wizard/onboarding-wizard.routes').then(
                x => x.onboardingWizardRoutes
            ),
    },
    {
        path: 'forget-password',
        loadComponent: () =>
            import('./pages/forget-password/forget-password.page').then(x => x.ForgetPasswordPage),
    },
    {
        path: 'change-password',
        loadComponent: () =>
            import('./pages/change-password/change-password.page').then(x => x.ChangePasswordPage),
    },
    {
        path: 'accept-invitation',
        loadComponent: () =>
            import('./pages/accept-invitation/accept-invitation.page').then(
                x => x.AcceptInvitationPage
            ),
    },
];
